import {Injectable} from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';

@Injectable()
export class HttpClient {

  private expired = new Subject<boolean>();

  constructor(private http: Http) {
  }

  createHeaders(): Headers {
    let headers = new Headers();

    let token = localStorage.getItem('token');
    if (token){
      headers.append('Authorization', 'Bearer ' + token);
    }
    headers.append('Content-Type', 'application/json');
    return headers;
  }

  createGetFilesHeaders(): Headers {
    let headers = new Headers();

    let token = localStorage.getItem('token');
    if (token){
      headers.append('Authorization', 'Bearer ' + token);
    }
    headers.append('Content-Type', 'application/json');
    headers.append('ResponseType', 'blob');
    return headers;
  }

  get(url) {
    return this.http.get( environment.API_URL + url, {
      headers: this.createHeaders()
    }).map(response => {
      return this.CustomErrorsHandler(response);
    }).catch(error => {
      return Observable.throw(error);
    });
  }

  getFiles(url, filterData: any = null) {
    const headers = this.createHeaders();
    const options = new RequestOptions({headers: headers, responseType: ResponseContentType.Blob });

    if(filterData){
      return this.http.post( environment.API_URL + url, filterData, options).map(response => {
        return this.CustomErrorsHandler(response);
      }).catch(error =>  {
        return Observable.throw(error);
      });
    }else{
      return this.http.get( environment.API_URL + url, options).map(response => {
        return this.CustomErrorsHandler(response);
      }).catch(error => {
        return Observable.throw(error);
      });
    }
  }

    postFiles(url) {
    return this.http.post( environment.API_URL + url, '', {
      headers: this.createGetFilesHeaders()
    }).map(response => {
      return this.CustomErrorsHandler(response);
    }).catch(error => {
      return Observable.throw(error);
    });
  }

  delete(url) {
    return this.http.delete( environment.API_URL + url, {
      headers: this.createHeaders()
    }).map(response => {
      return this.CustomErrorsHandler(response);
    }).catch(error => {
      return Observable.throw(error);
    });
  }

  post(url, data) {
    return this.http.post( environment.API_URL + url, data, {
      headers: this.createHeaders()
    }).map(response => {
      return this.CustomErrorsHandler(response);
    }).catch(error => {
      return Observable.throw(error);
    });
  }

  put(url, data){
    return this.http.put( environment.API_URL + url, data, {
      headers: this.createHeaders()
    }).map(response => {
      return this.CustomErrorsHandler(response);
    }).catch(error => {
      return Observable.throw(error);
    });
  }

  tokenExpired(){
    return this.expired.asObservable();
  }

  postGeneric<T>(URL: string, payload) {
    return this.post(URL, payload)
      .map((response: Response) => {
        if (response){
          return (response.json().ResponseData) as T;
        }
      });
  }

  getGeneric<T>(URL: string) {
    return this.get(URL)
      .map((response: Response) => {
        return response.json().ResponseData as T;
      });
  }

  CustomErrorsHandler(response: Response){
    let exceptionCode;
    try {
      exceptionCode = response.json().ExceptionCode;
    } catch {
      exceptionCode = null;
    }

    if (exceptionCode &&
    (exceptionCode.startsWith('AUTH004') ||
    exceptionCode.startsWith('AUTH005'))) {
          this.expired.next(true);
        }
    return response
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/http-client.ts